import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {InsightsComponent} from './pages/insights/insights.component';
import {PeopleComponent} from './pages/people/people.component';
import {PeopleProfileComponent} from './pages/people-profile/people-profile.component';
import {QuestionnairesComponent} from './pages/questionnaires/questionnaires.component';
import {RequestsComponent} from './pages/requests/requests.component';
import {QuestionnaireComponent} from './modules/questionnaire/questionnaire.component';
import {ProfileComponent} from "./pages/profile/profile.component";
import {AccountManagementComponent} from "./pages/account-management/account-management.component";
import {ReportComponent} from './pages/report/report.component';
import {ReferenceReportComponent} from "./pages/reference-report/reference-report.component";
import {CanDeactivateGuard} from "./services/can-deactivate-guard/can-deactivate.guard";
import {EmailSmsTemplateComponent} from "./pages/email-sms-template/email-sms-template.component";
import {SendXrefComponent} from "./components/send-xref/send-xref.component";
import {CreateSurveyComponent} from "./components/create-survey/create-survey.component";
import {PaymentCanActivateGuardService,SendXrefPermissionGuardService} from "./services/send-xref-permission-guard/send-xref-permission-guard.service";
import { LifecycleComponent } from "./components/reference-modal/components/lifecycle/lifecycle.component";
import { NoAccessComponent } from './pages/requests/no-access/no-access.component';
import { PermissionHelpComponent } from './pages/account-management/permission-help/permission-help.component';
import { BillingComponent } from "./components/billing/billing.component";
import { BillingGuards } from "./services/billing/billing-guard.service";
import { CreateTemplateComponent } from './pages/create-template/create-template.component';

const routes: Routes = [
  {path: 'no-access', component: NoAccessComponent, canActivate: [BillingGuards]},
  {path: 'billing', component: BillingComponent, canActivate: [BillingGuards], canDeactivate: [BillingGuards] },
  {path: 'requests', component: RequestsComponent, canActivate: [BillingGuards]},
  {path: 'people', component: PeopleComponent, canActivate: [BillingGuards]},
  {path: 'people/profile/:id', component: PeopleProfileComponent, canActivate: [BillingGuards]},
  {path: 'insights', component: InsightsComponent, canActivate: [BillingGuards]},
  {path: 'surveys', component: QuestionnairesComponent, canActivate: [BillingGuards]},
  {path: 'surveys/create', component: QuestionnaireComponent, canActivate: [BillingGuards], canDeactivate: [CanDeactivateGuard]},
  {path: 'surveys/edit', component: QuestionnaireComponent, canActivate: [BillingGuards], canDeactivate: [CanDeactivateGuard]},
  {path: 'surveys/start-point', component: CreateSurveyComponent, canActivate: [BillingGuards]},
  {path: 'request', component: SendXrefComponent, canDeactivate: [CanDeactivateGuard], canActivate: [BillingGuards, SendXrefPermissionGuardService, PaymentCanActivateGuardService]},
  {path: 'template', component: CreateTemplateComponent, canActivate: [BillingGuards], canDeactivate: [CanDeactivateGuard]},
  {path: 'lifecycle', component: LifecycleComponent, canActivate: [BillingGuards]},
  {path: 'report/:uid', component: ReportComponent, canActivate: [BillingGuards]},
  {path: 'reference-report/:checkId/referee/:refereeId', component: ReferenceReportComponent, canActivate: [BillingGuards]},
  {path: 'profile', component: ProfileComponent, canActivate: [BillingGuards], canDeactivate: [CanDeactivateGuard]},
  {path: 'account', component: AccountManagementComponent, canActivate: [BillingGuards], canDeactivate: [CanDeactivateGuard]},
  {path: 'account/:brand_name/email-sms-template', component: EmailSmsTemplateComponent, canActivate: [BillingGuards], canDeactivate: [CanDeactivateGuard]},
  {path: 'account/permission-help', component: PermissionHelpComponent, canActivate: [BillingGuards], canDeactivate: [CanDeactivateGuard]},
  {path: '**', redirectTo: 'requests'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled" })],
  exports: [RouterModule],
  providers: [
    SendXrefPermissionGuardService,
    PaymentCanActivateGuardService,
    BillingGuards
  ]
})
export class AppRoutingModule { }
